import { mapSupabaseError } from '../../lib/errors'
import { supabase } from '../../lib/supabase'
import { normalizeDocument } from '../../domain/document'
import type { CatalogKind, CatalogRecord } from '../../types/domain'

export type CatalogInput = {
  name: string
  document?: string
}

export async function listCatalog(kind: CatalogKind, activeOnly = false): Promise<CatalogRecord[]> {
  let query = supabase.from(kind).select('*').order('name')
  if (activeOnly) query = query.eq('is_active', true)
  const { data, error } = await query
  if (error) throw mapSupabaseError(error)
  return data as CatalogRecord[]
}

export async function createCatalogRecord(kind: CatalogKind, input: CatalogInput): Promise<CatalogRecord> {
  const base = { id: crypto.randomUUID(), name: input.name.trim() }
  const response = kind === 'clients'
    ? await supabase.from('clients').insert({
        ...base,
        document: normalizeDocument(input.document ?? '') || null,
      }).select('*').single()
    : kind === 'assignees'
      ? await supabase.from('assignees').insert(base).select('*').single()
      : await supabase.from('departments').insert(base).select('*').single()
  const { data, error } = response
  if (error) throw mapSupabaseError(error)
  return data as CatalogRecord
}

export async function updateCatalogRecord(
  kind: CatalogKind,
  id: string,
  input: CatalogInput,
): Promise<CatalogRecord> {
  const response = kind === 'clients'
    ? await supabase.from('clients').update({
        name: input.name.trim(),
        document: normalizeDocument(input.document ?? '') || null,
      }).eq('id', id).select('*').single()
    : kind === 'assignees'
      ? await supabase.from('assignees').update({ name: input.name.trim() }).eq('id', id).select('*').single()
      : await supabase.from('departments').update({ name: input.name.trim() }).eq('id', id).select('*').single()
  const { data, error } = response
  if (error) throw mapSupabaseError(error)
  return data as CatalogRecord
}

export async function setCatalogActive(
  kind: CatalogKind,
  id: string,
  isActive: boolean,
): Promise<CatalogRecord> {
  const response = kind === 'clients'
    ? await supabase.from('clients').update({ is_active: isActive }).eq('id', id).select('*').single()
    : kind === 'assignees'
      ? await supabase.from('assignees').update({ is_active: isActive }).eq('id', id).select('*').single()
      : await supabase.from('departments').update({ is_active: isActive }).eq('id', id).select('*').single()
  const { data, error } = response
  if (error) throw mapSupabaseError(error)
  return data as CatalogRecord
}
